/* ============================================================
   JAD — CORVETTE SPECS section class injector.
   Adds 4 unique classes to the homepage media-with-content section
   so CSS can target ONLY those elements without using global selectors.
   Classes added:
     .jad-corvette-specs           (the section wrapper)
     .jad-corvette-specs__heading  (the "Corvette Specs!" element)
     .jad-corvette-specs__list     (the bullet <ul>)
     .jad-corvette-specs__list-item (each <li> inside)
     .jad-corvette-specs__button   (the "Shop now" link)
   ============================================================ */
(function () {
  var SECTION_ID = 'shopify-section-media_with_content_39PEWa';

  function findSection() {
    var s = document.getElementById(SECTION_ID);
    if (s) return s;
    var candidates = document.querySelectorAll('main p, main h1, main h2, main h3, main h4');
    for (var i = 0; i < candidates.length; i++) {
      var t = (candidates[i].textContent || '').trim();
      if (/^corvette\s*specs/i.test(t)) {
        return candidates[i].closest('.shopify-section');
      }
    }
    return null;
  }

  function applyClasses() {
    var section = findSection();
    if (!section) return;
    section.classList.add('jad-corvette-specs');

    var headingCandidates = section.querySelectorAll('p, h1, h2, h3, h4');
    for (var j = 0; j < headingCandidates.length; j++) {
      var txt = (headingCandidates[j].textContent || '').trim();
      if (/^corvette\s*specs/i.test(txt)) {
        headingCandidates[j].classList.add('jad-corvette-specs__heading');
        break;
      }
    }

    var list = section.querySelector('ul');
    if (list) {
      list.classList.add('jad-corvette-specs__list');
      var items = list.querySelectorAll('li');
      for (var k = 0; k < items.length; k++) {
        items[k].classList.add('jad-corvette-specs__list-item');
      }
    }

    var btn = section.querySelector('a.button, a[class*="button"], button.button, button[class*="button"]');
    if (btn) btn.classList.add('jad-corvette-specs__button');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyClasses);
  } else {
    applyClasses();
  }
  document.addEventListener('shopify:section:load', applyClasses);
  setTimeout(applyClasses, 500);
  setTimeout(applyClasses, 1500);
  setTimeout(applyClasses, 3000);
})();
